import { Loader2, Lock, RadioTower } from "lucide-react";
import {
  providerOptions,
  type ProviderStepProps,
} from "./welcome-onboarding-types";

export function WelcomeProviderStep({
  apiKey,
  busy,
  isBusy,
  oauthCommand,
  onApiKeyChange,
  onConfirmGrok,
  onProviderChange,
  onSubmit,
  provider,
  surface,
}: ProviderStepProps) {
  const selected = providerOptions.find((item) => item.id === provider);
  const needsKey = Boolean(selected?.needsKey);
  const isGrok = provider === "hermes-grok";
  return (
    <section
      className="welcome-onboarding__panel welcome-onboarding__panel--stack"
      aria-label="AI provider onboarding"
    >
      <div className="welcome-onboarding__choice-grid welcome-onboarding__choice-grid--providers">
        {providerOptions.map((item) => (
          <button
            className={`welcome-onboarding__choice-card ${
              provider === item.id ? "is-active" : ""
            }`}
            key={item.id}
            onClick={() => onProviderChange(item.id)}
            type="button"
          >
            {item.id === "hermes-grok" ? (
              <RadioTower size={18} strokeWidth={1.8} />
            ) : (
              <Lock size={18} strokeWidth={1.8} />
            )}
            <strong>{item.label}</strong>
            <span>{item.detail}</span>
          </button>
        ))}
      </div>

      {surface === "mobile" && isGrok ? (
        <p className="welcome-onboarding__hint">
          Mobile can use Grok after Hermes OAuth is completed from Desktop or
          Web.
        </p>
      ) : null}

      {needsKey ? (
        <div className="welcome-onboarding__keyrow">
          <input
            type="password"
            value={apiKey}
            onChange={(event) => onApiKeyChange(event.target.value)}
            placeholder={
              provider === "deepseek-direct" ? "DeepSeek key" : "OpenCode key"
            }
          />
        </div>
      ) : null}

      {oauthCommand ? (
        <div className="welcome-onboarding__command">
          <code>{oauthCommand}</code>
          <button type="button" onClick={onConfirmGrok} disabled={isBusy}>
            I completed OAuth
          </button>
        </div>
      ) : null}

      <button
        className="welcome-onboarding__btn welcome-onboarding__btn--primary"
        disabled={isBusy || (needsKey && apiKey.trim().length < 10)}
        onClick={onSubmit}
        type="button"
      >
        {busy === "connecting" || busy === "saving" ? (
          <Loader2 size={16} strokeWidth={2.1} className="spin" />
        ) : provider === "hermes-grok" ? (
          <RadioTower size={16} strokeWidth={2.1} />
        ) : (
          <Lock size={16} strokeWidth={2.1} />
        )}
        <span>{labelForProvider(provider)}</span>
      </button>
    </section>
  );
}

function labelForProvider(provider: string): string {
  if (provider === "hermes-grok") return "Connect Grok";
  if (provider === "hermes-set-model") return "Use Hermes";
  if (provider === "opencode-go") return "Save OpenCode";
  return "Save DeepSeek";
}
